import React, { ComponentProps } from 'react';
import styles from './style.module.css';
import ReactModal from 'react-modal';

type ModalProps = {
  title?: string;
  subtitle?: string;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  shouldCloseOnOverlayClick?: boolean;
  width?: string;
} & ComponentProps<typeof ReactModal>;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    width: '900px',
    maxWidth: '90vw',
    padding: 18,
    paddingTop: 12,
    paddingBottom: 42,
    maxHeight: '95vh',
    backgroundColor: '#fff',
    color: '#000',
    transition: 'all 0.3s',
    border: 'none',
    borderRadius: 12,
  },
  overlay: {
    backgroundColor: '#1717253D',
    overscrollBehavior: 'contain',
    zIndex: 20,
  },
};

const Modal: React.FC<ModalProps> = ({
  title,
  subtitle,
  isOpen,
  onClose,
  width = '654px',
  shouldCloseOnOverlayClick = true,
  children,
  ...rest
}) => {
  React.useEffect(() => {
    // Check if modal is open and prevent body from scrolling
    if (typeof window !== 'undefined') {
      const body = document.body;

      if (isOpen) {
        // Disable scroll
        body.style.overflow = 'hidden';
        body.style.height = '100vh';
      } else {
        body.style.overflowY = 'auto';
        body.style.height = 'auto';
      }
    }
  }, [isOpen]);

  React.useEffect(() => {
    ReactModal.setAppElement('#root');
  }, []);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      // appElement={document.getElementById('modals')!}
      style={{
        // @ts-ignore
        content: {
          ...customStyles.content,
          width: width || customStyles.content?.width,
          opacity: isOpen ? 1 : 0,
        },
        overlay: customStyles.overlay,
      }}
      closeTimeoutMS={500}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      {...rest}
    >
      <div
        className={styles.modalTitleContainer}
        style={{
          justifyContent: title ? 'space-between' : 'flex-end',
        }}
      >
        <div className="flex flex-col gap-[3px]">
          {title && (
            <h1 className="text-xl font-bold text-BrandGray900">{title}</h1>
          )}
          {subtitle && (
            <h2 className="text-BrandGray800 text-sm">{subtitle}</h2>
          )}
        </div>
        <button
          onClick={onClose}
          style={{
            backgroundColor: 'transparent',
          }}
          className="text-BrandSecondary"
        >
          &#x2715;
        </button>
      </div>
      {children}
    </ReactModal>
  );
};

export default Modal;
